export default "__VITE_ASSET__EiCoAp3R__"